import { GetterTree } from 'vuex';

import { ConversationsStateI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<ConversationsStateI, RootStateI> = {
};
